import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
export class UtilityFunctions {
  // tslint:disable:no-trailing-whitespace max-line-length prefer-template

  sessionValue: String = '';
  waste = {
    i: '',
    le: '',
    nsro: '',
    ckwe: '',
    l: '',
    lke: '',
    y: '',
  };
  public uuid = {
    QVY: 1,
    '1b': null,
    W: 'a',
    dMQ0: '',
    Zxc: undefined,
    // 'S8q': 0,
    // 'XDdD': null,
    // 'dTd0e': '',
    // 'yk6LC': null,
    // 'N': undefined
  };

  getSessionKey(onlyKey?) {
    const cookie = document.cookie;
    let splitedCookie = [];
    splitedCookie = cookie.split(';');
    if (splitedCookie.length > 0) {
      splitedCookie.forEach((element) => {
        const tempList = element.split('=');
        if (tempList[0].trim() === 'session_id') {
          this.sessionValue = tempList[1];
        }
      });
      if (this.sessionValue.length) {
        this.sessionValue = this.sessionValue.substring(0, 16);
        this.sessionValue = CryptoJS.enc.Utf8.parse(this.sessionValue); // onlyKey ? this.sessionValue : CryptoJS.enc.Utf8.parse(this.sessionValue);
      }
      return this.sessionValue;
    }
  }

  // Enc Function
  encrypt(encData) {
    const key = this.getSessionKey(); // environment['EncryptionKey'];
    encData = JSON.stringify(encData);
    // msgString is expected to be Utf8 encoded
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(encData, key, {
      iv,
    });
    return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
  }

  // Dec Function
  decrypt(ciphertextStr) {
    const key = this.getSessionKey(); // environment['EncryptionKey'];
    const ciphertext = CryptoJS.enc.Base64.parse(ciphertextStr);
    // split IV and ciphertext
    const iv = ciphertext.clone();
    iv.sigBytes = 16;
    iv.clamp();
    ciphertext.words.splice(0, 4); // delete 4 words = 16 bytes
    ciphertext.sigBytes -= 16;

    // decryption
    const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, {
      iv,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  encryptPassword(encData, key?) {
    try {
      const tokenFromUI = key || environment['EncryptionKey'];
      const _key = CryptoJS.enc.Utf8.parse(tokenFromUI);
      const _iv = CryptoJS.enc.Utf8.parse(tokenFromUI);
      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(encData), _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString();
    } catch (error) {
      console.error(error);
    }
  }
  decryptPassword(ciphertextStr, key?) {
    try {
      const tokenFromUI = key || environment['EncryptionKey'];
      const _key = CryptoJS.enc.Utf8.parse(tokenFromUI);
      const _iv = CryptoJS.enc.Utf8.parse(tokenFromUI);
      const decrypted = CryptoJS.AES.decrypt(
        ciphertextStr, _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }).toString(CryptoJS.enc.Utf8);
      return JSON.parse(decrypted);
    } catch (error) {
      console.error(error);
      return ciphertextStr;
    }
  }
  returnK() {
    let k = '';
    // tslint:disable-next-line: forin
    for (const prop in this.waste) {
      k += prop;
    }
    return k;
  }
  generateUUID() {
    let k = '';
    // tslint:disable-next-line: forin
    for (const prop in this.uuid) {
      k += prop;
    }
    return k;
  }
  encryptLogin(encData) {
    try {
      const tokenFromUI = this.returnK(); // environment['loginEncryptionKey'];
      const _key = CryptoJS.enc.Utf8.parse(tokenFromUI);
      const _iv = CryptoJS.enc.Utf8.parse(tokenFromUI);
      encData = JSON.stringify(encData);
      // msgString is expected to be Utf8 encoded
      const encrypted = CryptoJS.AES.encrypt(encData, _key, {
        iv: _iv,
      });
      return _iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
    } catch (error) {
      console.error(error);
    }
  }
  decryptLogin(ciphertextStr) {
    try {
      const tokenFromUI = this.returnK(); // environment['loginEncryptionKey'];
      const _key = CryptoJS.enc.Utf8.parse(tokenFromUI);
      const ciphertext = CryptoJS.enc.Base64.parse(ciphertextStr);
      // split IV and ciphertext
      const iv = ciphertext.clone();
      iv.sigBytes = 16;
      iv.clamp();
      ciphertext.words.splice(0, 4); // delete 4 words = 16 bytes
      ciphertext.sigBytes -= 16;

      // decryption
      const decrypted = CryptoJS.AES.decrypt({ ciphertext }, _key, {
        iv,
      });
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error(error);
      return ciphertextStr;
    }
  }
  /**
   * Method to remove the counters which are used for Validation of the Nested Forms
   * @param counter_key Refers to the key to be removed
   * @param counter_array Refers to the Array To Iterate
   */
  removeValidationCounters(counter_key, counter_array) {
    try {
      if (!counter_key || !counter_array) {
        return;
      }
      const arrayToIterate = JSON.parse(JSON.stringify(counter_array));
      arrayToIterate.forEach((eachItem) => {
        delete eachItem[counter_key];
      });
      return arrayToIterate;
    } catch (error) {
      console.error(error);
    }
  }

  exportTable(reportName, tableData) {
    const uri = 'data:text/csv;charset=utf-8,' + escape(this.tableContentInString(',', tableData));
    const link = document.createElement('a');
    link.href = uri;
    link.setAttribute('style', 'visibility:hidden');
    link.download = reportName + '.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  tableContentInString(delimiter, tableData) {
    let CSV = '';
    tableData.headerContent.forEach((element, index) => {
      let header = (element['key']);
      header = (typeof header !== 'string') ? JSON.stringify(header) : header;
      CSV += (header || 'NA').replace(/,|\n/g, ' ') +
        (index === tableData.headerContent.length - 1 ? '' : delimiter);
    });
    CSV += '\n';
    tableData.bodyContent.forEach(row => {
      tableData.headerContent.forEach((col, index) => {
        const value = (row[col['key']] || '').toString();
        CSV += (value ? value : 'NA').replace(/,|\n/g, ' ') + (index === tableData.headerContent.length - 1 ? '' : delimiter);
      });
      CSV += '\n';
    });
    return CSV;
  }

  exportTableAsPdf(tableData: any, reportDetails?: any) {
    const styleTag = '<style>.table{width:100%;margin-bottom:1rem;background-color:transparent;border-spacing:0;border-collapse:collapse}.table th,.table td{// padding:0.75rem;vertical-align:top;border-top:1px solid #dee2e6}.table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.table tbody + tbody{border-top:2px solid #dee2e6}.table .table{background-color:#fff}.table-sm th,.table-sm td{padding:0.3rem}.table-bordered{border:1px solid #dee2e6}.table-bordered th,.table-bordered td{border:1px solid #dee2e6}.table-bordered thead th,.table-bordered thead td{border-bottom-width:2px}.table-borderless th,.table-borderless td,.table-borderless thead th,.table-borderless tbody + tbody{border:0}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,0.05)}.table-hover tbody tr:hover{background-color:rgba(0,0,0,0.075)}.table-primary,.table-primary > th,.table-primary > td{background-color:#b8daff}.table-primary th,.table-primary td,.table-primary thead th,.table-primary tbody + tbody{border-color:#7abaff}.table-hover .table-primary:hover{background-color:#9fcdff}.table-hover .table-primary:hover > td,.table-hover .table-primary:hover > th{background-color:#9fcdff}.table-secondary,.table-secondary > th,.table-secondary > td{background-color:#d6d8db}.table-secondary th,.table-secondary td,.table-secondary thead th,.table-secondary tbody + tbody{border-color:#b3b7bb}.table-hover .table-secondary:hover{background-color:#c8cbcf}.table-hover .table-secondary:hover > td,.table-hover .table-secondary:hover > th{background-color:#c8cbcf}.table-success,.table-success > th,.table-success > td{background-color:#c3e6cb}.table-success th,.table-success td,.table-success thead th,.table-success tbody + tbody{border-color:#8fd19e}.table-hover .table-success:hover{background-color:#b1dfbb}.table-hover .table-success:hover > td,.table-hover .table-success:hover > th{background-color:#b1dfbb}.table-info,.table-info > th,.table-info > td{background-color:#bee5eb}.table-info th,.table-info td,.table-info thead th,.table-info tbody + tbody{border-color:#86cfda}.table-hover .table-info:hover{background-color:#abdde5}.table-hover .table-info:hover > td,.table-hover .table-info:hover > th{background-color:#abdde5}.table-warning,.table-warning > th,.table-warning > td{background-color:#ffeeba}.table-warning th,.table-warning td,.table-warning thead th,.table-warning tbody + tbody{border-color:#ffdf7e}.table-hover .table-warning:hover{background-color:#ffe8a1}.table-hover .table-warning:hover > td,.table-hover .table-warning:hover > th{background-color:#ffe8a1}.table-danger,.table-danger > th,.table-danger > td{background-color:#f5c6cb}.table-danger th,.table-danger td,.table-danger thead th,.table-danger tbody + tbody{border-color:#ed969e}.table-hover .table-danger:hover{background-color:#f1b0b7}.table-hover .table-danger:hover > td,.table-hover .table-danger:hover > th{background-color:#f1b0b7}.table-light,.table-light > th,.table-light > td{background-color:#fdfdfe}.table-light th,.table-light td,.table-light thead th,.table-light tbody + tbody{border-color:#fbfcfc}.table-hover .table-light:hover{background-color:#ececf6}.table-hover .table-light:hover > td,.table-hover .table-light:hover > th{background-color:#ececf6}.table-dark,.table-dark > th,.table-dark > td{background-color:#c6c8ca}.table-dark th,.table-dark td,.table-dark thead th,.table-dark tbody + tbody{border-color:#95999c}.table-hover .table-dark:hover{background-color:#b9bbbe}.table-hover .table-dark:hover > td,.table-hover .table-dark:hover > th{background-color:#b9bbbe}.table-active,.table-active > th,.table-active > td{background-color:rgba(0,0,0,0.075)}.table-hover .table-active:hover{background-color:rgba(0,0,0,0.075)}.table-hover .table-active:hover > td,.table-hover .table-active:hover > th{background-color:rgba(0,0,0,0.075)}.table .thead-dark th{color:#fff;background-color:#212529;border-color:#32383e}.table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.table-dark{color:#fff;background-color:#212529}.table-dark th,.table-dark td,.table-dark thead th{border-color:#32383e}.table-dark.table-bordered{border:0}.table-dark.table-striped tbody tr:nth-of-type(odd){background-color:rgba(255,255,255,0.05)}.table-dark.table-hover tbody tr:hover{background-color:rgba(255,255,255,0.075)}.table tr th,.table tr td{min-width:110px !important;padding:4px 6px;font-size:12px;text-align:center;border-left:1px solid #dee2e6;border-top:1px solid #dee2e6;white-space:normal;border-spacing:0;border-collapse:collapse}</style>';
    const htmlOpeningTag = '<html><head><link rel="stylesheet" type="text/css" href="style.css"/>' + styleTag + '</head><body onload="window.print()" onafterprint="window.close()" style="font-family: reboto-regular;">';
    const htmlClosingTag = '</html>';
    let details = '';
    if (reportDetails) {
      details = `
      <div style="text-align:center"><h4 >Report Name : ${reportDetails['reportName']}</h4></div>
      <h6> Time of Creation : ${reportDetails['timeOfCreation']}</h6>
      <h6> Created by : ${reportDetails['createdby']}</h6>
      `;
    }
    let tableContent = details + '<table class="table table-striped table-bordered">';
    let headerContent = '<thead><tr>';
    for (const eachHeader of tableData.headerContent) {
      headerContent += '<th>' + eachHeader.label + '</th>';
    }
    headerContent += '</tr></thead>';
    let bodyContent = '<tbody>';
    for (const eachRow of tableData.bodyContent) {
      let tr = '<tr>';
      for (const eachHeader of tableData.headerContent) {
        tr += '<td>' + this.getvalue(eachRow[eachHeader.key]) + '</td>';
      }
      tr += '</tr>';
      bodyContent += tr;
    }
    bodyContent += '</tbody>';

    tableContent = tableContent + headerContent + bodyContent + '</table>';
    const popupWin = window.open();
    popupWin.document.open();
    popupWin.document.write(htmlOpeningTag + tableContent + htmlClosingTag);
    popupWin.document.close();
  }

  getvalue(value: any) {
    return value.replace(/,/g, ', ');
  }

  formatDate(date, dateFirst?) {
    const temp = new Date(date);
    let month = '' + (temp.getMonth() + 1);
    let day = '' + temp.getDate();
    const year = temp.getFullYear();
    month = month.length < 2 ? '0' + month : month;
    day = day.length < 2 ? '0' + day : day;
    return [dateFirst ? day : year, month, dateFirst ? year : day].join('-');
  }

  formatTime(time, onlyHM?) {
    const temp = new Date(time);
    let hours = '' + temp.getHours();
    let minutes = '' + temp.getMinutes();
    let seconds = onlyHM ? '00' : '' + temp.getSeconds();
    hours = hours.length < 2 ? '0' + hours : hours;
    minutes = minutes.length < 2 ? '0' + minutes : minutes;
    seconds = seconds.length < 2 ? '0' + seconds : seconds;
    return [hours, minutes, seconds].join(':');
  }
  toFixed(num, fixed) {
    const re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
    return num.toString().match(re)[0];
  }
  getFirstThreeCharacters(username) {
    try {
      let three = '';
      const len = username.length;
      if (len <= 3) {
        three = username + ('a'.repeat(3 - len));
      } else {
        three = username.slice(0, 3);
      }
      return three;
    } catch (e) {
      console.log(e);
    }
  }
  getLastThreeCharacters(username) {
    try {
      let three = '';
      const len = username.length;
      if (len <= 3) {
        three = username + ('a'.repeat(3 - len));
      } else {
        three = username.slice(0, 3);
      }
      return three;
    } catch (e) {
      console.log(e);
    }
  }
  encryptPasswordWithUsername(encData, username, token?) {
    console.log(encData,username,token,'password encryption');
    try {
      let tokenFromUI = '';
      if (token) {
        tokenFromUI = this.getLastThreeCharacters(username) + token;
      } else {
        tokenFromUI = this.getLastThreeCharacters(username) + this.generateUUID();
      }
      // tokenFromUI = this.getLastThreeCharacters(username) + this.generateUUID();
      const key = CryptoJS.enc.Utf8.parse(tokenFromUI);
      // encData = JSON.stringify(encData);
      const iv = CryptoJS.lib.WordArray.random(16);
      const encrypted = CryptoJS.AES.encrypt(encData, key, {
        iv,
      });
      return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
    } catch (error) {
      console.error(error);
    }
  }
}
